import { isDefined } from "@clipboard-health/util-ts";
import { CircularProgress } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";

import { AGENT_CASES_PATH } from "./paths";

const AgentCasesPage = lazy(async () =>
  import("./AgentCasesPage").then((module) => ({
    default: module.AgentCasesPage,
  }))
);

export function ProtectedAgentCasesPage() {
  const { userId, admin } = useSession();
  const isLoggedIn = isDefined(userId);

  if (!isLoggedIn) {
    localStorage.setItem("redirectURL", AGENT_CASES_PATH);
    return <Redirect to={`/enter?requestedUrl=${AGENT_CASES_PATH}`} />;
  }

  if (!admin) {
    return <Redirect to="/" />;
  }

  return (
    <Suspense fallback={<CircularProgress />}>
      <AgentCasesPage />
    </Suspense>
  );
}
